import iconStar3 from '@images/giraffe/icon-star3.png'
import iconStar2 from '@images/giraffe/icon-star2.png'
import iconStar1 from '@images/giraffe/icon-star1.png'
import iconSquare from '@images/giraffe/icon-square.png'

export const starImages = {
  0: iconSquare,
  1: iconStar1,
  2: iconStar2,
  3: iconStar3,
}
